import React from 'react';

import { timestamp } from '@spinnaker/core';
import { SortToggle } from '@spinnaker/core';
import { IDinghyEvent } from './dinghyEvents';
import { isEmpty } from 'lodash';

export interface DinghyEventsTableProps {
  events: IDinghyEvent[];
  currentSort: string;
  toggleSort: (column: string) => void;
  selectEvent: (event: IDinghyEvent) => void;
}

export class DinghyEventsTable extends React.Component<{ currentSort, toggleSort, events, selectEvent }, DinghyEventsTableProps> {

  constructor(props: { currentSort, toggleSort, events, selectEvent }) {
    super(props);
  }


  public renderStatus = ({status}): JSX.Element => {
    const isSuccess = status === 'success';
    const icon = isSuccess ? 'fa-check' : 'fa-exclamation-triangle'
    const content = isSuccess ? 'Succeeded' : 'Failed'
    return (
      <h5>
        <span className={`glyphicon status-glyph fa ${icon}`} />
        {content}
      </h5>
    );
  }


 public getAuthor = ({ rawdata }): JSX.Element => {
    const { pusher } = JSON.parse(rawdata)
    if (isEmpty(pusher)) {
      return null;
    }
    return (
      <div className="author-wrapper">
        <p className="name">
          <a href={`mailto:${pusher?.email}`}>
            {pusher?.name}
          </a>
        </p>
      </div>
    );
  }

  public concat(array): string[] {
    return array.map((item, index) => (index ? ', ' : '') + item);
  }

  public render() {
    const { currentSort, toggleSort, events, selectEvent } = this.props;

    return (
      <table className="table table-hover">
        <thead>
        <tr>
          <th style={{ width: '15%' }}>
            <SortToggle currentSort={currentSort} onChange={toggleSort} label="Timestamp" sortKey="date"/>
          </th>
          <th style={{ width: '15%' }}>
            <SortToggle currentSort={currentSort} onChange={toggleSort} label="Repository" sortKey="repo"/>
          </th>
          <th style={{ width: '20%' }}>Commit(s)</th>
          <th style={{ width: '15%' }}>Author</th>
          <th style={{ width: '10%' }}>File(s)</th>
          <th style={{ width: '10%' }}>Pull Request</th>
          <th style={{ width: '15%' }}>Status</th>
        </tr>
        </thead>

        <tbody>
        {events.map((event) => {
          return (
            <tr className="clickable" onClick={() => selectEvent(event)} key={event.date}>
              <td>{timestamp(event.date)}</td>
              <td>{event.org}/{event.repo}</td>
              <td>
                {event.commits ? this.concat(event.commits) : null}
              </td>
              <td>
                {this.getAuthor(event)}
              </td>
              <td>
                {event.files ? this.concat(event.files) : null}
              </td>
              <td>
                {event.pullrequest?.length !== 0 ? <a href={event.pullrequest} target="_blank">{event.pullrequest?.split('/')[6]}</a> : null}
              </td>
              <td>
                {this.renderStatus(event)}
              </td>
            </tr>
          );
        })}
        </tbody>
      </table>
    );
  }
}
